module.exports = __webpack_public_path__ + "img/books.bf5eb7b1.jpg";